export const en = {
    "account-linking": "Account linking",
    "error-ascii-activity": "Activity group ID can contain only ASCII characters",
    "error-ascii-app_id": "The application ID can contain only ASCII characters",
    "error-ascii-app_secret": "The application secret can only contain ASCII characters",
    "error-ascii-yandex_id": "OAuth application ID can only contain ASCII characters",
    "error-form": "Errors were encountered while validating the form.",
    "error-invalid_URL": "Invalid URL entered",
    "error-length-activity": "Activity group ID cannot contain more than 500 characters",
    "error-length-app_id": "The application ID cannot contain more than 100 characters",
    "error-length-app_secret": "The application secret cannot contain more than 100 characters",
    "error-length-authorisation": "Refresh token URL cannot contain more than 200 characters",
    "error-length-refresh-token": "Authorization URL cannot contain more than 200 characters",
    "error-length-token": "Get token URL cannot contain more than 200 characters",
    "error-length-yandex_id": "OAuth application ID cannot contain more than 100 characters",
    "error-occured": "Error occured",
    "label-auth_url": "Authorization URL",
    "label-client_id": "Application ID",
    "label-client_secret": "Application secret",
    "label-name": "Name",
    "label-refresh_token_url": "Refresh token URL",
    "label-scope": "Activity group ID",
    "label-token_url": "Get token URL",
    "label-yandex_client_id": "OAuth application ID",
    "warning-settings": "Changing the account linking settings can lead to logging out of your users, be careful!"
} as const;
export const ru = {
    "account-linking": "Связка аккаунтов",
    "error-ascii-activity": "Идентификатор группы действий может содержать только ASCII символы",
    "error-ascii-app_id": "Идентификатор приложения может содержать только ASCII символы",
    "error-ascii-app_secret": "Секрет приложения может содержать только ASCII символы",
    "error-ascii-yandex_id": "Идентификатор OAuth приложения может содержать только ASCII символы",
    "error-form": "При проверке формы обнаружены ошибки.",
    "error-invalid_URL": "Введён некорректный URL",
    "error-length-activity": "Идентификатор группы действий не может содержать более 500 символов",
    "error-length-app_id": "Идентификатор приложения не может содержать более 100 символов",
    "error-length-app_secret": "Секрет приложения не может содержать более 100 символов",
    "error-length-authorisation": "URL авторизации не может содержать более 200 символов",
    "error-length-refresh-token": "URL для обновления токена не может содержать более 200 символов",
    "error-length-token": "URL для получения токена не может содержать более 200 символов",
    "error-length-yandex_id": "Идентификатор OAuth приложения не может содержать более 100 символов",
    "error-occured": "Произошла ошибка",
    "label-auth_url": "URL авторизации",
    "label-client_id": "Идентификатор приложения",
    "label-client_secret": "Секрет приложения",
    "label-name": "Название",
    "label-refresh_token_url": "URL для обновления токена",
    "label-scope": "Идентификатор группы действий",
    "label-token_url": "URL для получения токена",
    "label-yandex_client_id": "Идентификатор OAuth приложения",
    "warning-settings": "Изменение настройки связки аккаунтов может привести к разлогину ваших пользователей, будьте внимательны!"
} as const;